import { AccountButton as AccountButtonBase } from "@omni/components/components/Navigation/Buttons/AccountButton/accountButton";
import { AccountButtonProps } from "@omni/types/components/props/accountButton.props";
import { BaseStore } from "@omni/types/enums/baseStore.enum";

import { AccountButtonComponent } from "@/components/Navigation/Buttons/AccountButton/accountButton.component";

export const AccountButton = ({
    icon,
    hover,
    alerts,
    invert,
    invertMobile,
    link,
    ariaLabel,
    text,
    textHidden,
    menuLinksSettings,
    redirect
}: AccountButtonProps<BaseStore.Hubo>) => {
    return (
        <AccountButtonBase
            icon={icon}
            hover={hover}
            alerts={alerts}
            invert={invert}
            invertMobile={invertMobile}
            link={link}
            ariaLabel={ariaLabel}
            text={text}
            textHidden={textHidden}
            menuLinksSettings={menuLinksSettings}
            redirect={redirect}
        >
            <AccountButtonComponent />
        </AccountButtonBase>
    );
};
